import Form from "./Form";
import { useToast } from "@chakra-ui/react";
import {
  CreateCategoryMutationVariables,
  useCreateCategoryMutation,
} from "../../generated/graphql";
import { useNavigate } from "react-router-dom";

const Create = () => {
  const [createCategory] = useCreateCategoryMutation();
  const navigation = useNavigate();
  const toast = useToast();
  const handleCreate = async (data: CreateCategoryMutationVariables) => {
    try {
      await createCategory({
        variables: {
          data: data.data,
        },
      });

      return toast({
        status: "success",
        title: "Başarılı",
        description: "Kategori eklendi",
        duration: 1000,
        onCloseComplete: () => {
          return navigation("/category");
        },
      });
    } catch (error: any) {
      return toast({
        status: "error",
        title: "Hata",
        description: error.message || "Bir hata oluştu",
        duration: 1000,
      });
    }
  };
  return <Form handleCreate={handleCreate} actionType="CREATE" />;
};

export default Create;
